import 'core-js/modules/es.array.iterator';
import 'core-js/modules/es.array.map';
import 'core-js/modules/es.function.name';
import 'core-js/modules/es.object.assign';
import 'core-js/modules/es.object.to-string';
import 'core-js/modules/es.promise';
import 'core-js/modules/es.regexp.exec';
import 'core-js/modules/es.string.iterator';
import 'core-js/modules/es.string.replace';
import 'core-js/modules/es.string.split';
import 'core-js/modules/web.dom-collections.iterator';
import 'regenerator-runtime/runtime';
import Globalize from '@paypalcorp/globalize/dist/globalize';
import { isPlainObject } from 'is-plain-object';
import { assertType, assert } from 'yaassertion';
import LRU from 'lru-cache';
import axios from 'axios';
import semver from 'semver';

function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}

/**
 * Given a locale, it  will return certain old locales to new form
 * @param {locale} locale to replace
 * @return {new_locale}
 */
function normalizeLocale(locale) {
  // prettier-ignore
  return locale.replace(/\bno\b/, "nb").replace(/\btl\b/, "fil");
}

/**
 * Function that normalizes locale according to paypal standards. It performs the following operations on locale:
 * 1) replaces '_' with '-' in locale string. E.g., 'en_US' will be replaced with 'en-US'
 * 2) replaces 'C2' with 'CN-xbord'. E.g., 'en-C2' will be 'en-CN-xbord'
 * 3) replaces no with nb
 * 4) replaces tl with fil. E.g., 'tl-PH' will be replaced to 'fil-PH'
 * @param {String} locale bcp-47 locale value (en-US, fr-FR, etc)
 * @param {Object} options an object that can take prop named langSubtag
 * @returns {String} normalized locale value
 */
function _normalizeLocale(locale, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$langSubtag = _ref.langSubtag,
    langSubtag = _ref$langSubtag === void 0 ? true : _ref$langSubtag;
  if (locale.payPalLocaleCode) {
    // A payPalLocaleCode to existing limited locale support.
    var _locale$payPalLocaleC = locale.payPalLocaleCode,
      _locale = _locale$payPalLocaleC.locale,
      _country = _locale$payPalLocaleC.country;
    var _locale$split = _locale.split(/[-_]/),
      _localeLanguage = _locale$split[0];
    locale = _localeLanguage + "-" + _country;

    // A payPalLocaleCode to standard locale normalization: (when PayPal supports all locales anywhere)
    // const { locale: _locale } = locale.payPalLocaleCode;
    // const [_localeLanguage, _localeCountry] = _locale.split(/[-_]/);
    // if (_localeCountry === "XC") {
    //   if (_localeLanguage === "es") {
    //     // es_XC -> es-MX
    //     locale = "es-MX";
    //   } else {
    //     // fr_XC -> fr
    //     // zh_XC -> zh
    //     locale = _localeLanguage;
    //   }
    // } else {
    //   locale = _locale;
    // }
  }
  if (process.env.NODE_ENV !== "production") {
    assert(typeof locale === "string", typeof locale === "object" ? "Invalid locale {{locale}}. Did you mean {{didYouMean}}?" : "Invalid locale {{locale}}", {
      locale: locale,
      didYouMean: {
        payPalLocaleCode: locale
      }
    });
  }
  locale = locale
  // Support both _ & - as locale separator.
  // Note: This must precede other replaces using `\b`.
  .replace(/_/, "-")
  // If locale includes C2, replace it with CN-xbord
  .replace(/\bC2\b/, "CN-xbord");
  if (langSubtag) {
    locale = normalizeLocale(locale);
  }
  return locale;
}
var countryAliasMapping = {
  C2: "CN",
  UK: "GB"
};
function getResolvedRegion(region) {
  return countryAliasMapping[region] || region;
}
var ENVIRONMENT = {
  PRODUCTION: "production"
};
var DOCUMENTATION_HOMEPAGE = "https://github.paypal.com/pages/Globalization-R/worldready-js/docs";

/**
 * max: maximum number of keys that the cache can have
 * ttl: time to live in milliseconds (currently it's set to 10 minutes)
 */
var DEFAULT_CACHE_CONFIG = {
  max: 400,
  ttl: 10 * 60 * 1000
};

/**
 * Wrapper for LRU cache that can be used across worldready sdk.
 */
var Cache = /*#__PURE__*/function () {
  function Cache(options) {
    if (options === void 0) {
      options = {};
    }
    if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
      assertType(options, "options", ["plain object"]);
    }
    options = Object.assign({}, DEFAULT_CACHE_CONFIG, options);
    this.cache = new LRU(options);
  }

  /**
   * Utility function to set the value in cache.
   * @param {String} key string value that should be used as cache key
   * @param {Any} value value that needs to be stored in cache (can be string, number, object, etc.)
   * @param {Object} options an optional object that can have following props:
   *  size
   *  sizeCalculation
   *  ttl
   *  noDisposeOnSet
   *  start
   * For more details, refer this link: https://github.com/isaacs/node-lru-cache#setkey-value--size-sizecalculation-ttl-nodisposeonset-start-
   * @returns {Any} value that's added to the cache
   */
  var _proto = Cache.prototype;
  _proto.set = function set(key, value, options) {
    if (options === void 0) {
      options = {};
    }
    return this.cache.set(key, value, options);
  }

  /**
   * Utility function to retrieve a value from cache.
   * @param {String} key string value that was used as key while entering the value in cache
   * @param {Object} options an optional object that can have following props:
   *  updateAgeOnGet
   *  allowStale
   * For more details, refer this link: https://github.com/isaacs/node-lru-cache#getkey--updateageonget-allowstale-----value
   * @returns {Any} value that's stored in cache for the corresponding key. It'll return undefined if key is not found.
   */;
  _proto.get = function get(key, options) {
    if (options === void 0) {
      options = {};
    }
    return this.cache.get(key, options);
  }

  /**
   * Utility function to check if value for a certain key is present in cache or not.
   * @param {*} key string value that could've been used as key while entering the value in cache
   * @param {*} options an optional object that can have following props:
   *  updateAgeOnHas: if set to false, the recency of the key won't be updated
   * @returns {Boolean}
   */;
  _proto.has = function has(key, options) {
    if (options === void 0) {
      options = {};
    }
    return this.cache.has(key, options);
  }

  /**
   * Utility function to delete a key from cache.
   * @param {String} key string value that was used as key while entering the value in cache
   * @returns {Boolean} true if key was found, otherwise false
   */;
  _proto.delete = function _delete(key) {
    return this.cache.delete(key);
  }

  /**
   * Utility function to get total number of items present in cache.
   */;
  _proto.size = function size() {
    return this.cache.size;
  }

  /**
   * Helper function to clear contents of cache.
   */;
  _proto.clear = function clear() {
    return this.cache.clear();
  };
  return Cache;
}(); // Internationalization and localization data providers array:
var isWorldReadyLoadCalled;
var isWorldReadyInstance = function isWorldReadyInstance(object) {
  return object && object.globalize;
};

/**
 * Region
 */
var Region = /*#__PURE__*/function () {
  function Region() {}
  Region.getRegionString = function getRegionString(worldReadyOrRegionOrString) {
    if (worldReadyOrRegionOrString && worldReadyOrRegionOrString.region) {
      return getResolvedRegion(worldReadyOrRegionOrString.region);
    }
    return getResolvedRegion(worldReadyOrRegionOrString);
  };
  return Region;
}();
if (process.env.NODE_ENV !== "production") {
  Region.assertType = function (parameterValue, parameterName) {
    assertType(parameterValue, parameterName, ["string", "object"]);
  };
}

/**
 * WorldReady
 */
var WorldReady = function WorldReady(locale) {
  var _main;
  if (process.env.NODE_ENV !== "production") {
    assert(isWorldReadyLoadCalled, "Load WorldReady metadata first. Please read " + DOCUMENTATION_HOMEPAGE + "/about-load-worldready-data.html");
  }
  if (!(this instanceof WorldReady)) {
    return new WorldReady(locale);
  }

  // TODO assert locale
  locale = _normalizeLocale(locale);

  // Hack: set any locale as available locale.
  Globalize.load({
    main: (_main = {}, _main[locale] = {}, _main)
  });
  this.globalize = new Globalize(locale);
  var cldr = this.globalize.cldr;
  this.bundle = cldr.attributes.bundle;
  this.locale = cldr.locale;
  this.language = cldr.attributes.language;
  this.region = cldr.attributes.region;
  this.market = this.region;
  this.weekInfo = {
    minDays: cldr.get(["supplemental/weekData/minDays", this.region]) || cldr.get("supplemental/weekData/minDays/001"),
    firstDay: cldr.get(["supplemental/weekData/firstDay", this.region]) || cldr.get("supplemental/weekData/firstDay/001"),
    weekendStart: cldr.get(["supplemental/weekData/weekendStart", this.region]) || cldr.get("supplemental/weekData/weekendStart/001"),
    weekendEnd: cldr.get(["supplemental/weekData/weekendEnd", this.region]) || cldr.get("supplemental/weekData/weekendEnd/001")
  };
  this.metadata = cldr.get(["metadata"]) || {};
};

/**
 * async WorldReady.load()
 */
{
  // Client-side
  WorldReady.load = function () {
    // TODO assert params
    isWorldReadyLoadCalled = true;
    for (var _len = arguments.length, providers = new Array(_len), _key = 0; _key < _len; _key++) {
      providers[_key] = arguments[_key];
    }
    providers.map(function (provider) {
      if (isPlainObject(provider)) {
        Globalize.load(provider);
        return;
      }
      throw new Error("Oops: Async provider not supported in browsers at the moment");
    });
  };
}
WorldReady._Globalize = Globalize;
WorldReady.cache = new Cache();

/**
 * WorldReady features skeleton
 */
if (process.env.NODE_ENV !== "production") {
  var loadError = function loadError(feature) {
    return function () {
      throw new Error("Missing feature, you may want to `import @paypalcorp/worldready-" + feature + "`");
    };
  };
  WorldReady.prototype.Address = loadError("address");
  WorldReady.prototype.RelativeTimeFormat = loadError("relative-time");
  WorldReady.prototype.MessageFormat = loadError("message");
  WorldReady.prototype.NumberFormat = loadError("number");
  WorldReady.prototype.CurrencyFormat = loadError("currency");
}
var Griffin = WorldReady;
var version = "2.0.0";
var WORLDREADY_CDN_NAMESPACE = "worldready-i18n-metadata";
var LIVE_CDN_BASE_URL = "https://www.paypalobjects.com";
var QA_CDN_BASE_URL = "https://cdn-latest.static.engineering.dev.paypalinc.com";
var CDN_LIVE_WORLDREADY_BASE_URL = LIVE_CDN_BASE_URL + "/" + WORLDREADY_CDN_NAMESPACE;
var CDN_QA_WORLDREADY_BASE_URL = QA_CDN_BASE_URL + "/" + WORLDREADY_CDN_NAMESPACE;
var getLiveCDNURL = function getLiveCDNURL(version) {
  if (!version) {
    return "" + CDN_LIVE_WORLDREADY_BASE_URL;
  }
  return CDN_LIVE_WORLDREADY_BASE_URL + "/" + version;
};
var getQACDNURLForLatestBundle = function getQACDNURLForLatestBundle(version) {
  if (!version) {
    return "" + CDN_QA_WORLDREADY_BASE_URL;
  }
  return CDN_QA_WORLDREADY_BASE_URL + "/" + version;
};
var WorldReadyError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(WorldReadyError, _Error);
  function WorldReadyError(message) {
    var _this;
    _this = _Error.call(this, message || "") || this;
    _this.code = "WORLDREADY_ERROR";
    return _this;
  }
  return WorldReadyError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
var WorldReadyCDNError = /*#__PURE__*/function (_WorldReadyError) {
  _inheritsLoose(WorldReadyCDNError, _WorldReadyError);
  function WorldReadyCDNError(errorObj, _ref2) {
    var _this2;
    var code = _ref2.code,
      service = _ref2.service;
    var _ref3 = errorObj || {
        message: "Error while loading metadata from CDN.",
        statusCode: "NA"
      },
      message = _ref3.message,
      statusCode = _ref3.statusCode,
      details = _ref3.details;
    var statusCodeMessage = statusCode && " Status code: " + statusCode || "";
    _this2 = _WorldReadyError.call(this, "" + message + statusCodeMessage) || this;
    _this2.name = _this2.constructor.name;
    _this2.code = code || "WORDLREADY_CDN_ERROR";
    _this2.details = details;
    _this2.statusCode = statusCode;
    _this2.service = service || "NA";
    return _this2;
  }
  return WorldReadyCDNError;
}(WorldReadyError);
/**
 * Function that resolves what version of metadata needs to be fetched from
 * CDN based on a given major version.
 * @param {Number} majorVersion
 */
var resolveMetadataVersion = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(majorVersion) {
    var _cdnConfig$data, _cdnConfig$data2, CDN_URL, cdnConfig;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          CDN_URL = getCDNURL();
          _context.next = 4;
          return axios.get(CDN_URL + "/config.json");
        case 4:
          cdnConfig = _context.sent;
          if (!((_cdnConfig$data = cdnConfig.data) != null && _cdnConfig$data.versions && (_cdnConfig$data2 = cdnConfig.data) != null && _cdnConfig$data2.versions[majorVersion])) {
            _context.next = 9;
            break;
          }
          return _context.abrupt("return", cdnConfig.data.versions[majorVersion].version);
        case 9:
          throw new Error("Metadata for requested version (" + majorVersion + ") was not found. Please make sure you are using an official version of the worldready-js library");
        case 10:
          _context.next = 16;
          break;
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](0);
          if (_context.t0.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            _context.t0.statusCode = _context.t0.response.status;
          }
          throw new WorldReadyCDNError(_context.t0, {
            code: "CDN_LOAD_ERROR",
            service: _context.t0.statusCode && "paypalObjectsCDN"
          });
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 12]]);
  }));
  return function resolveMetadataVersion(_x) {
    return _ref4.apply(this, arguments);
  };
}();

/**
 * Function that constructs CDN URL based on the metadata version.
 */
var getCDNURL = function getCDNURL(version) {
  if (process.env.NODE_ENV === ENVIRONMENT.PRODUCTION) {
    return getLiveCDNURL(version);
  } else {
    return getQACDNURLForLatestBundle(version);
  }
};

/**
 * Function to load internationalization metadata from CDN.
 * @param {Object} params an object which should contain following props:
 *  - locale: valid bcp-47 string indicating for which locale should worldready sdk load metadata for
 *      (e.g., en-US, fr-CA, etc.)
 */
WorldReady.loadI18nMetadata = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(params) {
    var locale, normalizedLocale, cdnMajorVersion, CDN_METADATA_VERSION, CDN_URL, localeMetadataResponse, commonMetadataResponse, _yield$Promise$all, localeMetadata, commonMetadata;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          if (!(!params || !(params != null && params.locale) || (params == null ? void 0 : params.locale) === "")) {
            _context2.next = 3;
            break;
          }
          throw new Error("Invalid params were provided. Please pass a valid params object in order to load metadata from CDN.");
        case 3:
          locale = params.locale; // Having this assert will be useful if clients pass a non-string value for locale param
          assertType(locale, "locale", ["string"]);
          normalizedLocale = _normalizeLocale(locale);
          cdnMajorVersion = semver.major(version);
          _context2.next = 9;
          return resolveMetadataVersion(cdnMajorVersion);
        case 9:
          CDN_METADATA_VERSION = _context2.sent;
          CDN_URL = getCDNURL(CDN_METADATA_VERSION);
          localeMetadataResponse = axios.get(CDN_URL + "/" + normalizedLocale + ".json");
          commonMetadataResponse = axios.get(CDN_URL + "/supplemental.json");
          _context2.next = 15;
          return Promise.all([localeMetadataResponse, commonMetadataResponse]);
        case 15:
          _yield$Promise$all = _context2.sent;
          localeMetadata = _yield$Promise$all[0];
          commonMetadata = _yield$Promise$all[1];
          WorldReady.load(localeMetadata.data, commonMetadata.data);
          _context2.next = 25;
          break;
        case 21:
          _context2.prev = 21;
          _context2.t0 = _context2["catch"](0);
          if (_context2.t0.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            _context2.t0.statusCode = _context2.t0.response.status;
          }
          throw new WorldReadyCDNError(_context2.t0, {
            code: "CDN_LOAD_ERROR",
            service: _context2.t0.statusCode && "paypalObjectsCDN"
          });
        case 25:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 21]]);
  }));
  return function (_x2) {
    return _ref5.apply(this, arguments);
  };
}();

export { Griffin, Region, WorldReady, isWorldReadyInstance };
